// Legacy `clrCode` values always disabled in the correction letter popup. The
// legacy expression is truncated in the source review, so this list may be incomplete.
export const LOCKED_CORRECTION_REASON_CODES: ReadonlySet<string> = new Set(["VSC_PROV", "VSC_T_MILE", "VSC_T_MNTH"]);
